/**
 * 动态表单接口
 * @author： xuyd
 * @date：2024-05-05
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 检索表单列表
   */
  searchFormList: (params) => {
    return request.post(serviceModule + "/jimu/form/search", params);
  },

  /**
   * 保存表单信息
   */
  getFormInfo: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/jimu/form/info/get", {params});
  },

  /**
   * 保存表单信息
   */
  saveForm: (params) => {
    return request.post(serviceModule + "/jimu/form/info/save", params);
  },

  /**
   * 删除表单
   * @param id 表单id
   */
  deleteForm: (id) => {
    return request.get(serviceModule + "/jimu/form/delete?id=" + id);
  },

  /////////////////////////////////////////////////////////////////////////////////////

  /**
   * 检索表单组件列表
   * @param pageId 表单id
   */
  selectWidgetList: (pageId) => {
    let params = {pageId: pageId}
    return request.get(serviceModule + "/jimu/form/widget/select", {params});
  },

  /**
   * 查询表单组件内容，比如重新加载该组件
   * @param id
   */
  reload: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/jimu/form/widget/reload", {params});
  },

  /**
   * 添加表单组件
   * @param params
   */
  addWidget: (params) => {
    return request.post(serviceModule + "/jimu/form/widget/add", params);
  },

  /**
   * 更新表单组件
   *
   * @param params
   */
  updateWidgetList: (params) => {
    return request.post(serviceModule + "/jimu/form/widget/update", params);
  },
  /**
   * 删除表单组件内容
   *
   * @param id
   */
  deleteWidget: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/jimu/form/widget/delete", {params});
  },

}
